import React from 'react';
import { ArrowRight, Clock, GraduationCap, Sparkles, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const StudentDreamMastery = () => {
  return (
    <div className="bg-exiser-light min-h-screen">
      {/* Hero Section */}
      <div className="bg-exiser-primary text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" />

        <div className="max-w-5xl mx-auto px-4 relative z-10 text-center">
          <div className="flex justify-center md:justify-start mb-6">
            <Link to="/categories" className="inline-flex items-center gap-2 text-white/70 hover:text-white uppercase tracking-wider text-xs font-bold transition-colors">
              <ArrowLeft className="w-4 h-4" /> Back to Programmes
            </Link>
          </div>

          {/* Subtitle / Badge as Pill */}
          <div className="inline-flex items-center gap-2 bg-exiser-accent/20 border border-exiser-accent/60 px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
            <Sparkles className="w-4 h-4 text-exiser-accent fill-current" />
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-exiser-accent">
              Clarity • Focus • Career Direction
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-bold uppercase tracking-tight mb-6 leading-tight">
            Career Dream Mastery
          </h1>

          {/* Main Description */}
          <p className="text-base md:text-lg text-purple-100 max-w-3xl mx-auto font-sans leading-relaxed">
            Career Dream Mastery helps students and young professionals gain
            clarity about their dreams, build focus and create a realistic
            action roadmap.
          </p>
        </div>
      </div>

      {/* Main Content Card - Floating overlap */}
      <div className="max-w-4xl mx-auto px-4 -mt-12 relative z-20 pb-20">
        <div className="bg-white rounded-2xl shadow-xl border border-purple-100 p-8 md:p-12 text-center space-y-8">

          {/* Visual Icon */}
          <div className="w-16 h-16 bg-purple-50 rounded-2xl rotate-3 flex items-center justify-center mx-auto text-exiser-primary shadow-sm border border-purple-100">
            <GraduationCap className="w-8 h-8" />
          </div>

          <div className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold uppercase text-gray-900 tracking-tight">
              Program Details Updating Soon
            </h2>

            {/* Secondary Content */}
            <p className="text-gray-600 font-sans text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Detailed modules, timelines and bonuses will be published here. You
              can continue to use the Programmes section to enroll.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/categories"
              className="inline-flex items-center gap-2 bg-exiser-primary text-white px-8 py-4 text-xs md:text-sm font-bold uppercase tracking-[0.2em] rounded-xl hover:bg-purple-900 shadow-lg transition-all hover:-translate-y-1"
            >
              Visit Programmes & Investment
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

          <div className="flex items-center justify-center gap-2 text-[10px] text-gray-400 font-bold uppercase tracking-widest mt-6">
            <Clock className="w-3 h-3" />
            <span>Enrollment is currently open</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDreamMastery;